import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getDisplayImageUrl } from '../../utils/imageUtils';

const MediaLibrary = ({ onSelect }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/media`);
        setImages(res.data);
      } catch (error) {
        console.error('Error al obtener las imágenes', error);
      }
    };

    fetchImages();
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {images.map((img) => (
          <div key={img._id} style={{ margin: '10px' }}>
            <img
              src={getDisplayImageUrl(img.filename)}
              alt={img.originalname}
              width="100"
              style={{ cursor: 'pointer' }}
              onClick={() => onSelect(img)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MediaLibrary;